import * as React from 'react';
import * as moment from 'moment';
import * as _ from 'lodash';
import * as qs from 'query-string';
import * as Cookies from "universal-cookie";
import { Dispatch, connect } from 'react-redux';
import { downloadFile } from '@nkr/services/download-file';
import { IReportState, ReportActionCreators, CenterActionCreators, IApplicationState, AppActionCreators, IBasicCenterListResponse, IAppState, IComparisonVolumeResponse } from '@nkr/store/index';
import { ISortBy, ICenterBase, ICenter, IComparisonVolume } from '@nkr/models/index';
import { OrganType } from '@nkr/enums/organ-type';
import { Glyphicon, DropdownButton, MenuItem } from 'react-bootstrap';
import DataRow from './data-row';
import { TableWrapper } from './styles';
import Filter from './filter';
import CompareNav from '../comparison-conversion/nav';
import FooterRow from './footer-row';
import ReactHtmlParser from 'react-html-parser';

interface IOwnProps {
    centerId: number,
    isAdmin: boolean
}

interface IStateProps {
    reports: IReportState
    centerList: ICenter[],
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getBasicCenterList: () => Promise<IBasicCenterListResponse>,
    getComparisonVolume: (includeNkr: boolean, includeDcn: boolean, includeDash: boolean, donationType: number) => Promise<IComparisonVolumeResponse>,
    getComparisonVolumeExport: (includeNkr: boolean, includeDcn: boolean, includeDash: boolean, donationType: number) => Promise<any>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    report: IComparisonVolume[],
    includeDash: boolean,
    includeDcn: boolean,
    includeNkr: boolean,
    organType: number,
    sortBy: ISortBy[],
    centerList: ICenterBase[],
}

class ComparisonVolumeReport extends React.Component<TProps, IState> {
    readonly state: IState = {
        report: [],
        includeDash: true,
        includeDcn: false,
        includeNkr: false,
        organType: 1,
        sortBy: [],
        centerList: [],
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        let newType = this.props.app.site.organType == OrganType.Kidney ? 1 : 2;
        let parsed = qs.parse(location.search.length > 0 ? location.search : encodeURI("dataview=1&sites[]=dash"));
        let cookies = new Cookies();

        let organTypeFromCookie = cookies.get('organType');

        if (organTypeFromCookie == null) {
            const current = new Date();
            const nextYear = new Date();

            nextYear.setFullYear(current.getFullYear() + 1);

            cookies.set("organType", newType, { path: "/", expires: nextYear, domain: __DOMAIN__, secure: __ISSECURE__, httpOnly: false });

            organTypeFromCookie = newType;
        }

        let organTypeForPayload = organTypeFromCookie;

        if (parsed.organType != null) {
            organTypeForPayload = parsed.organType;
        }

        this.props.showLoading("Getting report data, one moment please...").then(() => {
            Promise.all([
                this.props.getComparisonVolume(this.state.includeNkr, this.state.includeDcn, this.state.includeDash, this.state.organType),
                this.props.getBasicCenterList()
            ])
                .then(([comparisonConversionResponse, centerListResponse]) => {
                    let { reportResults: report } = comparisonConversionResponse.data.results;

                    this.setState({
                        report,
                        centerList: centerListResponse.data.results,
                        organType: organTypeForPayload
                    }, () => {
                        if (this.props.isAdmin == false) {
                            this.setConversionUrl();
                        }

                        this.props.hideLoading();
                    });
                }).catch(() => {
                    alert('An error occured while loading report data');
                    this.props.hideLoading();
                })
        }).catch(() => {
            this.props.hideLoading();
        });
    }

    getSortedData = () => {
        const sortByProperties = this.state.sortBy.map((sortBy) => sortBy.property);
        const sortByDirections = this.state.sortBy.map((sortBy) => sortBy.direction);

        let sortedRows = [];

        if (sortByProperties.some(this.checkNonNumbers)) {
            sortedRows = this.state.sortBy.length > 0 ? _.orderBy(this.state.report, (item) => {
                return sortByProperties.map(sortBy => {
                    return item[sortBy];
                });
            }, sortByDirections) : this.state.report;
        } else {
            sortedRows = this.state.sortBy.length > 0 ? _.orderBy(this.state.report, (item) => {
                return Number(sortByProperties.map(property => {
                    return (item[property]);
                }));
            }, sortByDirections) : this.state.report;
        }

        return sortedRows;
    }

    checkNonNumbers = (value: string) => {
        switch (value) {
            case 'centerAlias': return true;
            default: return false;
        }
    }

    handleFilterChange = (property: string) => {
        if (property == 'includeNkr') {
            this.setState({
                includeNkr: !this.state.includeNkr
            });
        }

        if (property == 'includeDcn') {
            this.setState({
                includeDcn: !this.state.includeDcn
            });
        }

        if (property == 'includeDash') {
            this.setState({
                includeDash: !this.state.includeDash
            });
        }
    }

    handleFilter = () => {
        let { includeNkr, includeDcn, includeDash, organType } = this.state;

        this.props.showLoading("Searching, one moment please...").then(() => {
            this.props.getComparisonVolume(includeNkr, includeDcn, includeDash, organType).then(response => {
                if (response.data.success) {
                    let { reportResults: report } = response.data.results;

                    this.setState({
                        report
                    }, () => {
                        this.setConversionUrl();
                        this.props.hideLoading();
                    });
                } else {
                    this.props.hideLoading();
                }
            });
        })
    }

    handleOrganFilter = (organType: number) => {
        this.setState({
            organType
        }, () => {
            // let cookies = new Cookies();

            let { includeNkr, includeDcn, includeDash, organType } = this.state;

            this.props.showLoading("Searching, one moment please...").then(() => {
                this.props.getComparisonVolume(includeNkr, includeDcn, includeDash, organType).then(response => {
                    if (response.data.success) {
                        // cookies.set("dashview", response.data.results.donationType, { path: "/", domain: __DOMAIN__, secure: __ISSECURE__, httpOnly: false });

                        let { reportResults: report, } = response.data.results;

                        this.setState({
                            report
                        }, () => {
                            this.setConversionUrl();
                            this.props.hideLoading();
                        });
                    } else {
                        this.props.hideLoading();
                    }
                });
            });
        });
    }

    handleExport = () => {
        let { includeNkr, includeDcn, includeDash, organType } = this.state;

        this.props.showLoading("Exporting CSV file, one moment please...").then(() => {
            this.props.getComparisonVolumeExport(includeNkr, includeDcn, includeDash, organType).then((response: any) => {

                downloadFile(response.data, `Compare-Volume.csv`, 'text/csv');

                this.props.hideLoading();
            });
        });
    }

    setConversionUrl = () => {
        let { includeDash, includeDcn, includeNkr, organType } = this.state;

        let paramList = [];

        if (includeDash) {
            paramList.push(encodeURI('sites[]=dash'));
        }

        if (includeDcn) {
            paramList.push(encodeURI('sites[]=dcn'));
        }

        if (includeNkr) {
            paramList.push(encodeURI('sites[]=nkr'));
        }

        if (organType != null) {
            paramList.push(encodeURI('organType=' + organType));
        }

        let params = paramList.join('&');

        let newUrl = '/center/' + this.props.centerId + '/reports/dash-board/compare-volume?' + params;

        window.history.pushState({}, '', newUrl);
    }

    getOrganTypeTitle = () => {
        if (this.state.organType == 1) {
            return 'Kidney Only';
        }

        if (this.state.organType == 2) {
            return 'Liver Only';
        }

        if (this.state.organType == 3) {
            return 'Liver & Kidney';
        }
    }

    handleSort = (property: string) => {
        let sortBy = _.cloneDeep(this.state.sortBy);
        let sort = sortBy.find(item => item.property == property);

        if (sort != null) {
            if (sort.direction == 'asc') {
                sort.direction = 'desc'
            } else {
                if (sort.direction == 'desc') {
                    sortBy = sortBy.filter(item => item.property != property);
                }
            }
        } else {
            sortBy.push({ property, direction: 'asc' });
        }

        this.setState({
            sortBy
        });
    }

    renderHeaderSort = (property: string) => {
        let sortItem = this.state.sortBy.find(item => item.property == property);

        if (sortItem != null) {
            return <Glyphicon glyph={sortItem.direction == 'asc' ? 'triangle-top' : 'triangle-bottom'} style={{ marginLeft: 5 }} />;
        } else {
            return null;
        }
    }

    render = () => {
        let sortedRows = this.getSortedData();

        const organTypeTitle = this.getOrganTypeTitle();

        const cols = _.range(11, 1, -1).map(monthIndex => {
            return { field: 'monthsAgo' + monthIndex, label: moment().add(monthIndex * -1, 'months').format('MMMM<br/>YYYY') };
        });

        return (
            <>
                <div style={{ marginBottom: 10, padding: '0px 5px 5px 5px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5 }}>
                        <div>
                            <CompareNav activeKey='VOLUME' centerId={this.props.centerId} isAdmin={this.props.isAdmin} />
                        </div>

                        {this.props.app.site.organType != OrganType.Liver && (
                            <div>View:&nbsp;
                                <DropdownButton bsStyle='primary' pullRight title={organTypeTitle} id='organType'>
                                    <MenuItem onClick={() => this.handleOrganFilter(2)}>Liver Candidates</MenuItem>
                                    <MenuItem onClick={() => this.handleOrganFilter(1)}>Kidney Candidates</MenuItem>
                                    <MenuItem onClick={() => this.handleOrganFilter(3)}>Liver &amp; Kidney Candidates</MenuItem>
                                </DropdownButton>
                            </div>
                        )}
                    </div>

                    <Filter
                        isAdmin={false}
                        isLiverCenterView={this.props.isAdmin == false && this.props.app.site.organType == OrganType.Liver}
                        centerId={this.props.centerId}
                        includeDash={this.state.includeDash}
                        includeDcn={this.state.includeDcn}
                        includeNkr={this.state.includeNkr}
                        centerList={this.state.centerList}
                        onChange={this.handleFilterChange}
                        onFilter={this.handleFilter}
                        onExport={this.handleExport}
                    />

                    <div style={{ width: '100%' }}>
                        <TableWrapper bordered condensed striped style={{ borderTop: 'none', borderRight: 'none' }}>
                            <thead>
                                <tr>
                                    <th rowSpan={2}>Rank</th>
                                    <th rowSpan={2} onClick={() => this.handleSort('centerAlias')}>Center {this.renderHeaderSort('centerAlias')}</th>
                                    <th colSpan={cols.length + 3}>Referrals</th>
                                </tr>
                                <tr>
                                    {cols.map((col, index) =>
                                        <th style={{ width: '6.5%' }} key={'month-col-' + index} onClick={() => this.handleSort(col.field)}><div><span>{ReactHtmlParser(col.label)} {this.renderHeaderSort(col.field)}</span></div></th>
                                    )}

                                    <th style={{ width: '6.5%' }} onClick={() => this.handleSort('lastMonth')}>Last<br />Month {this.renderHeaderSort('lastMonth')}</th>
                                    <th style={{ width: '6.5%' }} onClick={() => this.handleSort('thisMonth')}>Current<br />Month {this.renderHeaderSort('thisMonth')}</th>
                                    <th style={{ width: '6.5%' }} onClick={() => this.handleSort('total')}>Total in<br />Last Year {this.renderHeaderSort('total')}</th>
                                </tr>
                            </thead>

                            <tbody>
                                {sortedRows.map((item, index) =>
                                    <DataRow
                                        key={'conv-row-' + index}
                                        index={index}
                                        item={item}
                                        includeDash={this.state.includeDash}
                                        includeDcn={this.state.includeDcn}
                                        includeNkr={this.state.includeNkr}
                                        centerId={this.props.centerId}
                                    />
                                )}
                            </tbody>

                            <tfoot>
                                <FooterRow report={this.state.report} />
                            </tfoot>
                        </TableWrapper>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        reports: appState.reports,
        centerList: appState.centers.list,
        app: appState.app
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getBasicCenterList: () => {
            return dispatch(CenterActionCreators.getBasicCenterList(false));
        },
        getComparisonVolume: (includeNkr, includeDcn, includeDash, donationType) => {
            return dispatch(ReportActionCreators.getComparisonVolume(includeNkr, includeDcn, includeDash, donationType));
        },
        getComparisonVolumeExport: (includeNkr, includeDcn, includeDash, donationType) => {
            return dispatch(ReportActionCreators.getComparisonVolumeExport(includeNkr, includeDcn, includeDash, donationType))
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(ComparisonVolumeReport);